import useProjectOutputsQuery from 'shared/api/projects/useProjectOutputsQuery';
import useProjectQuery from 'shared/api/projects/useProjectQuery';

const useDashboardData = (projectId) => {
  const { data: project } = useProjectQuery(projectId);
  const { data: outputs } = useProjectOutputsQuery(projectId);

  return {
    projectId,
    project,
    outputs
  };
};

export default useDashboardData;
